module.exports = __webpack_public_path__ + "img/emoji_7.45105fab.png";